<template>
  <div>
    <div class="setup-content contact-info" id="step-8">
      <h3 class="color-darkblue">Attachments</h3>
      <div class="form-row row-cols-md-2 row-cols-1 ach-payment-section">
        <div class="col form-group verification-section-main">
          <label v-if="attachmentRequired" :class="'control-label require'">File:</label>
          <label v-else :class="'control-label'">File:</label>
          <div class="custom-dropzone-container custom-photo-user-dropzone dropzone-margin">
            <div id="app2">
              <vue-dropzone id="warrantyClaimDocs" :options="dropzoneOptions" :destroyDropzone=false
                ref="warrentyClaimDropZone" :headers="dropzoneOptions.headers" @vdropzone-complete="afterComplete"
                @vdropzone-success="storeDocument" @vdropzone-removed-file="removedSelectedFile">
              </vue-dropzone>
              <div class="field-error">{{ fileerror_msg }}</div>
            </div>
          </div>
        </div>
        <div class="col form-group" v-if="dropZonePreviewFiles.length > 0">
          <div class="policy-attachment attachment-list-box">
            <label class="control-label" for="attachments"></label>
            <template v-for="(uFile, fKey) in dropZonePreviewFiles">
              <div v-bind:key="'fileDiv' + fKey" class="attachment-list">
                <i v-if="uFile.extension == 'pdf'" class="fp-pdf-icon"></i>
                <i v-if="uFile.extension == 'doc' || uFile.extension == 'docs'" class="fp-text-document"></i>
                <i v-if="uFile.extension == 'jpg' || uFile.extension == 'png' || uFile.extension == 'jpeg'"
                  class="fp-image"></i>
                <a title='View File' href="javascript:void(0)" v-on:click="openDocument(uFile.url, uFile.extension)"
                  v-bind:key="'fileName' + fKey">
                  {{ uFile.display_name }}
                </a>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <button type="button" v-bind:key="'cancelBtn' + fKey"
                  v-on:click="deleteWarrantyFile(fKey, uFile.file_name);">
                  <i class="fp-close"></i>
                </button>
              </div>
            </template>
          </div>
        </div>
      </div>
      <div class="alert alert-warning hide col-sm-6">
        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span
            aria-hidden="true">&times;</span></button>
        <strong class="errormsg"></strong>
      </div>
      <div class="alert alert-warning hide w-50">
        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span
            aria-hidden="true">&times;</span></button>
        <strong class="errormsg"></strong>
      </div>
      <div class="btn-groups mt-3">
        <button type="button"
        v-on:click="updateLineItems()" class="btn btn-primary">
        <i class="fp-edit"></i> Edit
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { contractMixins } from '../../mixins/contractMixins';
import { commonMixins } from '../../mixins/commonMixins';
import LoadingContent from "@/components/LoadingContent.vue";
Vue.component("loading-content", LoadingContent);

import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';

export default {
  name: "EvAttachmentTabSection",
  components: {
    vueDropzone: vue2Dropzone,
    appFooter: () => import('@/components/Footer')
  },
  mixins: [commonMixins, contractMixins],
  props: ["attachmentTabData", "claimId", "hideEditSection"],
  data: () => ({
    dropzoneOptions: {
      url: process.env.ROOT_API + "/store-warranty-claim-docs",
      method: 'POST',
      maxFilesize: 10.00, //MB
      maxFiles: 5,
      thumbnailWidth: 150, // px
      thumbnailHeight: 150,
      addRemoveLinks: true,
      acceptedFiles: ".jpg, .jpeg, .png, .pdf , .doc ,.docx",
      headers: this.ajxHeaders,
      dictRemoveFileConfirmation: "Are you sure?You can\'t revert your action",
      destroyDropzone: false,
      dictDefaultMessage: "Drop files here to upload. Max allowed file size is 10MB.",
    },
    dropZonePreviewFiles: [],
    fileerror_msg: "",
    docArr: [],
    validateDocs: [],
    filesArr: [],
    warranty_id: "",
    isEdit: false,
    attachmentRequired: false,
  }),
  created() {
    this.populateData();
  },
  methods: {
    populateData() {
      this.isEdit = true;
      this.warranty_id = this.claimId;
      if (this.attachmentTabData.file_path != null) {
        this.dropZonePreviewFiles = this.attachmentTabData.file_path;
      }
      if (this.dropZonePreviewFiles != null) {
        this.loadFilesPreview();
      }
    },
        //load files in drop zone
        loadFilesPreview() {
      var self = this;
      self.docArr = [];
      self.validateDocs = [];
      if (self.dropZonePreviewFiles.length > 0) {
        for (var i = 0; i < self.dropZonePreviewFiles.length; i++) {
          var url = self.dropZonePreviewFiles[i].url;
          // get file path from url
          self.docArr.push(self.getFilePathFromUrl(self.dropZonePreviewFiles[i].url));
          self.validateDocs.push({
            file_name: self.dropZonePreviewFiles[i].display_name,
            extension: self.dropZonePreviewFiles[i].extension
          });
        }
      }
    },
    getFilePathFromUrl(value) {

      var path = "";
      var src = value.split('/');
      var file_name = src[src.length - 1];
      var orgPath = src[src.length - 2];
      path = orgPath + "/" + file_name;
      return path;

    },
    deleteWarrantyFile: function (key, file) {

      var self = this;

      if (confirm('Are you sure that you want to remove file? ')) {

        if (self.warranty_id != '' && self.warranty_id != undefined) {
          self.$parent.loading = true;

          $.ajax({
            url: process.env.ROOT_API + "/remove-warranty-claim-file",
            type: "POST",
            crossDomain: true,
            dataType: "json",
            headers: this.ajxHeaders,
            data: {
              warranty_id: self.warranty_id,
              doc_path: file
            },
            success: function (data) {
              self.$parent.loading = false;
              if (data.status == "success") {
                self.filesArr.splice(key, 1);
                self.docArr.splice(key, 1);
                self.validateDocs.splice(key, 1);
                self.dropZonePreviewFiles.splice(key,1);
                if (self.valuesFound) {
                  self.valuesFound = false;
                  self.matchingValuesError = [];
                }
              }
            },
            error: function (jqXHR, exception) {
              self.$parent.loading = false;
              self.filesArr.splice(key, 1);
              self.docArr.splice(key, 1);
              self.validateDocs.splice(key, 1);
              self.generateStatusCodeMessage(jqXHR, true, 'vendor-invoice-doc-remove');
            }
          });

        } else {
          self.filesArr.splice(key, 1);
          self.$refs.files.value = '';
        }
      }

    },
    removedSelectedFile(file, xhr, error) {
      var self = this;
      self.fileerror_msg = "";
      if (file.xhr != undefined) {
        var fileName = JSON.parse(file.xhr.response).content;

        var fileArr = fileName.split("/");

        self.removeFileFromServer(fileArr[1], "temp");

        for (var i = 0; i < self.docArr.length; i++) {
          if (self.docArr[i].includes(fileName)) {
            self.docArr.splice(i, 1);
            self.validateDocs.splice(i, 1);
            self.filesArr.splice(i, 1);
          }
        }
      }
    },
    removeFileFromServer(file, flag) {
      var self = this;
      var billId = self.$route.params.id;
      self.loading = true;
      $.ajax({
        url: process.env.ROOT_API + "/remove-warranty-claim-file",
        type: "POST",
        data: {
          doc_path: file,
          bill_id: billId,
          flag: flag
        },
        headers: this.ajxHeaders,
        dataType: "json",
        success: function (data) {
          self.loading = false;
        },
        error: function (jqXHR, exception) {
          self.loading = false;
          self.generateStatusCodeMessage(jqXHR, true, 'vendor-inv-doc-remove')
        }
      });
    },
    removeAllFiles() {
      var self = this;
      self.$refs.warrentyClaimDropZone.removeAllFiles();
    },
    storeDocument(file, response) {
      var self = this;
      self.fileerror_msg = "";
      var uploadResponse = response;

      //push doc path in doc array
      self.docArr.push(uploadResponse.content);
      self.filesArr.push(file);
      if (file.type != undefined) {
        var extension = file.type.split("/");
        self.validateDocs.push({
          file_name: file.name,
          size: file.size,
          extension: extension[1]
        });
      }
    },
    afterComplete(file, response) {
      var self = this;
    },
    validateBeforeSubmit() {
      var self = this;
      var success = true;
      const validExtensions = ["jpeg", "png", "jpg", "pdf", "doc", "docx", "msword", "vnd.openxmlformats-officedocument.wordprocessingml.document"];

      if (self.docArr != null && self.docArr.length > 0) {
        if (self.validateDocs.length > 0) {
          for (var i = 0; i < self.validateDocs.length; i++) {
            let fileObj = self.validateDocs[i];

            if (fileObj.extension != undefined) {
              if (validExtensions.includes(fileObj.extension)) {
                success = true;
              } else {
                self.fileerror_msg = "Only Images or PDF or Doc Files Are Allowed (.jpg / .jpeg / .png / .pdf / .doc / .docx).";
                success = false;
              }
            }

            if (fileObj.size != undefined) {
              if (fileObj.size > 10000000) {
                self.fileerror_msg = "File size should not be greater than 10 MB.";
                success = false;
              }
            }
          }
        }
        if (self.docArr.length > 5) {
          self.fileerror_msg = "Cannot upload more than 5 files.";
          success = false;
        }
      } else {
        if (self.attachmentRequired) {
          self.fileerror_msg = "File needs to be uploaded since, price was input by user in part tab!";
          success = false;
        }
      }
      return success;
    },
    prepareDataForUpdating() {
      const attachmentData = {
        attachedData: this.docArr,
        claimId: this.claimId
      };
      return attachmentData;
    },
    updateLineItems(){
      var self = this;
      var success = self.validateBeforeSubmit();
      if(success){
        const attachmentData = this.prepareDataForUpdating();
        self.$parent.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/update/attachment-section",
            type: "POST",
            data: {
              attachmentData: attachmentData,
              claimId: self.claimId,
            },
            headers: this.ajxHeaders,
            dataType: "json",
            cors: true,
            success: function (data) {
              self.$parent.loading = false;
              if (data.status == "success") {
                self.hideEditSection("attachment");
              } else {
                console.log("Error");
              }
            },
            error: function (jqXHR, exception) {
              self.$parent.loading = false;
              console.log("ERRORRRR");
            },
          });
      }
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/warrantyClaimTabs/EvAttachmentTabSection.vue